module.exports = __webpack_public_path__ + "static/media/referredPartners.f3041170.png";